// Cookieless Plausible wrapper. The Plausible script (loaded in index.html only when
// VITE_PLAUSIBLE_DOMAIN is set) defines window.plausible. This wrapper no-ops otherwise,
// so analytics is fully inert in dev / until configured. No PII in events.
declare global {
  interface Window {
    plausible?: (event: string, opts?: { props?: Record<string, string | number> }) => void;
  }
}

export function track(event: string, props?: Record<string, string | number>): void {
  if (typeof window === 'undefined' || typeof window.plausible !== 'function') return;
  window.plausible(event, props ? { props } : undefined);
}

export {}; // ensure module scope for the global augmentation
